class AccordionsModule {
  constructor(container) {
    this.container = container;
    this.accordionPanels = container.querySelectorAll('.accordions__panel');
    this.accordionQuestions = container.querySelectorAll('.accordions__question');
    this.accordionImages = container.querySelectorAll('.accordions__image');
    this.init();
  }

  init() {
    this.accordionQuestions.forEach(question => {
      question.addEventListener('click', (e) => this.togglePanel(e, question));
      question.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          question.click();
        }
      });
    });
  }

  togglePanel(event, question) {
    const expanded = question.getAttribute('aria-expanded') === 'true';
    const answerId = question.getAttribute('aria-controls');
    const answer = this.container.querySelector(`#${answerId}`);
    const panel = question.closest('.accordions__panel');
    const panelIndex = Array.from(this.accordionPanels).indexOf(panel);

    // Close all panels within this module
    this.accordionPanels.forEach((panel, index) => {
      const panelQuestion = panel.querySelector('.accordions__question');
      const panelAnswer = panel.querySelector('.accordions__answer');
      const icon = panelQuestion.querySelector('.accordions__toggle i');

      // Set current height to trigger a smooth collapse
      panelAnswer.style.height = panelAnswer.scrollHeight + 'px';
      panelAnswer.offsetHeight; // Force reflow
      panelAnswer.style.height = '0';

      panel.classList.remove('active');
      panelQuestion.setAttribute('aria-expanded', 'false');
      panelAnswer.setAttribute('aria-hidden', 'true');

      if (icon) {
        icon.classList.remove('icon--minus');
        icon.classList.add('icon--plus');
      }

      // Remove active state from the corresponding image
      if (this.accordionImages[index]) {
        this.accordionImages[index].classList.remove('active');
      }
    });

    // Open the clicked panel if it was not already expanded
    if (!expanded) {
      question.setAttribute('aria-expanded', 'true');
      panel.classList.add('active');
      answer.style.height = answer.scrollHeight + 'px';
      answer.setAttribute('aria-hidden', 'false');

      const activeIcon = question.querySelector('.accordions__toggle i');
      if (activeIcon) {
        activeIcon.classList.remove('icon--plus');
        activeIcon.classList.add('icon--minus');
      }

      // Activate the corresponding image for the open panel
      if (this.accordionImages[panelIndex]) {
        this.accordionImages[panelIndex].classList.add('active');
      }
    }

    // Fallback: if no panel is active, activate the first image
    if (!this.container.querySelector('.accordions__panel.active') && this.accordionImages.length > 0) {
      this.accordionImages[0].classList.add('active');
    }

    // If a panel was opened, delay scrollIntoView to match the 500ms expand duration
    if (!expanded) {
      setTimeout(() => {
        const panelRect = panel.getBoundingClientRect();
        const panelTop = panelRect.top + window.scrollY;
        const panelHeight = panelRect.height;
        const viewportHeight = window.innerHeight;
      
        const nav = document.querySelector('.navigation');
        const navHeight = nav ? nav.offsetHeight : 0;
      
        // If the panel is already near the top (possibly under the nav), offset it below the nav
        const isNearTop = panelRect.top < navHeight;
      
        const scrollTo = isNearTop
          ? panelTop - navHeight
          : panelTop - (viewportHeight / 2 - panelHeight / 2);
      
        window.scrollTo({
          top: scrollTo,
          behavior: 'smooth',
        });
      }, 500);      
    }
  }
}

// Initialize each module independently.
document.querySelectorAll('.accordions').forEach(moduleContainer => {
  new AccordionsModule(moduleContainer);
});